module.exports = __webpack_public_path__ + "static/media/pultec-bg-4.363b0059.jpg";